// services/platforms.ts — SATU-SATUNYA daftar platform (sumber traffic) baku.
// Sama dengan opsi dropdown filter Platform di pesanan:
// meta, tiktok, google, snack, whatsapp (platformDropdown.tsx).
// 'prospek' / 'cs-form' / 'admin_manual' / '' BUKAN platform — dilarang tulis
// ke orders.utmSource (insiden 2026-10-05: kolom Platform tampil "prospek"/"-").

export const PLATFORM_SOURCES = ['meta', 'tiktok', 'google', 'snack', 'whatsapp'] as const;

export type PlatformSource = (typeof PLATFORM_SOURCES)[number];

const LABELS: Record<PlatformSource, string> = {
  meta: 'Meta',
  tiktok: 'TikTok',
  google: 'Google',
  snack: 'Snack Video',
  whatsapp: 'WhatsApp',
};

// Kanonikalisasi nilai bebas → platform baku. Tak dikenal (termasuk 'prospek',
// 'cs-form', 'biteship') → fallback. Untuk alur chat/prospek fallback =
// 'whatsapp' (lead lahir dari chat WA; TrafficSourceCell pakai konvensi sama).
// Untuk submit publik fallback = '' (trafik direct memang tanpa platform).
export function canonPlatform(v: unknown, fallback: string = 'whatsapp'): string {
  const s = String(v || '').trim().toLowerCase();
  if ((PLATFORM_SOURCES as readonly string[]).includes(s)) return s;
  // Alias umum iklan: fb/ig/facebook/instagram = meta; wa = whatsapp.
  if (s === 'fb' || s === 'ig' || s === 'facebook' || s === 'instagram') return 'meta';
  if (s === 'wa') return 'whatsapp';
  return fallback;
}

// Label tampil kolom Platform. Nilai baku → label cantik; legacy tak dikenal
// → apa adanya (jangan sembunyikan data); kosong → '-'.
export function platformLabel(v: unknown): string {
  const s = String(v || '').trim().toLowerCase();
  if (!s) return '-';
  return LABELS[s as PlatformSource] || String(v);
}
